// App Store + Google Play indirme badge'leri (founder 2026-06-22) — davet smart-link
// mobil ekranında gösterilir. URL yoksa (ör. Android henüz yok) badge soluk + tıklanamaz.

interface BadgeProps {
  /** Store URL. Boşsa badge "yakında" olarak soluk + tıklanamaz render edilir. */
  href?: string;
}

function AppleGlyph() {
  return (
    <svg viewBox="0 0 384 512" className="h-6 w-6 shrink-0 fill-white" aria-hidden="true">
      <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
    </svg>
  );
}

function PlayGlyph() {
  // 4 renkli "play" üçgeni: A(üst-sol) B(alt-sol) C(sağ apex), F(katlama) + M(sol orta).
  return (
    <svg viewBox="0 0 24 24" className="h-6 w-6 shrink-0" aria-hidden="true">
      <polygon points="5,3.5 5,12 10,12" fill="#34A853" />
      <polygon points="5,12 5,20.5 10,12" fill="#FBBC04" />
      <polygon points="5,3.5 10,12 20,12" fill="#4285F4" />
      <polygon points="5,20.5 10,12 20,12" fill="#EA4335" />
    </svg>
  );
}

function Badge({
  href,
  glyph,
  line1,
  line2,
  ariaLabel,
}: BadgeProps & {
  glyph: React.ReactNode;
  line1: string;
  line2: string;
  ariaLabel: string;
}) {
  const inner = (
    <span className="flex w-full items-center justify-center gap-1.5 rounded-xl bg-black px-2.5 py-2.5 text-white">
      {glyph}
      <span className="flex flex-col whitespace-nowrap text-left leading-none">
        <span className="text-[9px] font-medium tracking-wide">{line1}</span>
        <span className="-mt-0.5 text-[15px] font-semibold leading-tight">{line2}</span>
      </span>
    </span>
  );
  if (!href) {
    return (
      <div className="max-w-[170px] flex-1 cursor-default opacity-40" title="Yakında" aria-disabled="true">
        {inner}
      </div>
    );
  }
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={ariaLabel}
      className="block max-w-[170px] flex-1 rounded-xl transition-transform hover:scale-[1.02] focus:outline-none focus-visible:ring-2 focus-visible:ring-custel-ink focus-visible:ring-offset-2"
    >
      {inner}
    </a>
  );
}

export function AppStoreBadge({ href }: BadgeProps) {
  return (
    <Badge
      href={href}
      glyph={<AppleGlyph />}
      line1="Download on the"
      line2="App Store"
      ariaLabel="App Store'dan indir"
    />
  );
}

export function GooglePlayBadge({ href }: BadgeProps) {
  return (
    <Badge href={href} glyph={<PlayGlyph />} line1="GET IT ON" line2="Google Play" ariaLabel="Google Play'den indir" />
  );
}
